import angular from 'angular';
import constants from 'app/constants';
import {
  bcpDataService,
  ssDialogService,
  loaderService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-server-dialog.controller';
import template from './edit-server-dialog.html';


class dialogService {
  getOptions($event, { assessmentId, server, addCallback }) {
    return {
      controller,
      controllerAs: 'editServerDialogVM',
      locals: {
        assessmentId,
        server,
        addCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.bcp.editServerDialog', [
  alerts,
  bcpDataService,
  constants,
  ssDialogService,
  loaderService,
])
  .service('editServerDialog', dialogService)
  .name;
